<template>
    <div class="col-12 col-sm-12 col-xl">
        <!--begin::Card-->
        <div class="card h-100">
            <!--begin::Card body-->
            <div v-if="isLoading" class="pa-4">
                <el-skeleton type="card" :loading="true" animated />
            </div>
            <div v-else>
                <div class="d-flex justify-end pa-2">
                    <el-popconfirm title="Are you sure to delete this?" @confirm="$emit('delete')">
                        <template #reference>
                            <i class="ti ti-trash text-red cursor-pointer px-2"></i>
                        </template>
                    </el-popconfirm>
                    <i @click="$emit('edit')" class="ti ti-pencil text-blue-500 cursor-pointer"></i>
                </div>
                <div @click="$emit('view')" class="card-body d-flex justify-content-center text-center flex-column p-8">
                    <!--begin::Name-->
                    <a href="#" class="text-gray-800 text-hover-primary d-flex flex-column">
                        <!--begin::Image-->
                        <div class="symbol symbol-60px mb-6">
                            <img :src="`/images/icons/${computedFileType}.png`" alt="file icon" />
                        </div>
                        <!--end::Image-->

                        <!--begin::Title-->
                        <div class="fs-5 fw-semibold mb-2">
                            {{ fileTitle }}
                        </div>
                        <div class="fs-7 text-gray-400">
                            {{ fileType }}
                        </div>
                        <!--end::Title-->
                    </a>
                    <!--end::Name-->

                    <!--begin::Description-->
                    <div class="fs-7 fw-semibold text-gray-400 mt-auto">
                        {{ createdAt }}
                    </div>
                    <!--end::Description-->
                </div>
            </div>

            <!--end::Card body-->
        </div>
        <!--end::Card-->
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue'

    export default defineComponent({
        name: 'file-component',
        emits: ['view', 'edit', 'delete'],
        props: {
            fileTitle: {
                type: String,
                required: true,
            },

            fileType: {
                type: String,
                default: '',
            },
            createdAt: {
                type: String,
                required: true,
            },
            filename: {
                type: String,
                required: true,
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const extensionToFileType: Record<string, string> = {
                jpg: 'image',
                jpeg: 'image',
                png: 'image',
                gif: 'image',
                webp: 'image',
                pdf: 'pdf',
                doc: 'word',
                docx: 'word',
                xls: 'excel',
                xlsx: 'excel',
                txt: 'txt',
                rar: 'rar',
                zip: 'zip',
                default: 'file',
            }

            const getFileExtension = (filename: string): string => filename.split('.').pop()?.toLowerCase() || 'default'

            const computedFileType = computed(() => {
                const ext = getFileExtension(props.filename)
                return extensionToFileType[ext] || extensionToFileType.default
            })
            const isLoading = computed(() => props.loading)
            return {
                computedFileType,
                isLoading,
            }
        },
    })
</script>
